<span [class]="cssClass">{{ displayText }}</span>
